














































































import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../honcierge-api"
import { AlertLevel } from "types/postscript"
import { AxiosError } from "axios"

@Component
export default class EditPostscript extends Vue {
  @Prop()
  private dialog!: boolean

  public id = -1 // 正なら新規作成, そうでないなら更新処理を行う
  public alertLevel: AlertLevel["value"] = ""
  public alertLevelJp: AlertLevel["key"] = ""
  public category = ""
  public validText = ""
  public invalidText = ""
  public description = ""

  private alertLevels: AlertLevel[] = []

  // rules for form
  private validTextRules = [
    (name: string) => !!name || "正しいテキストは必須です",
  ]
  private invalidTextRules = [
    (name: string) => !!name || "間違ったテキストは必須です",
  ]

  public updatePostscript(): void {
    if (!this.validate()) {
      return
    }
    api
      .updatePostscript({
        id: this.id,
        alertLevel: this.alertLevel,
        invalidText: this.invalidText,
        validText: this.validText,
        category: this.category,
        description: this.description,
      })
      .then(() => {
        this.emitPostscript()
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  public createPostscript(): void {
    if (!this.validate()) {
      return
    }
    api
      .createPostscript({
        alertLevel: this.alertLevel,
        invalidText: this.invalidText,
        validText: this.validText,
        category: this.category,
        description: this.description,
      })
      .then(() => {
        this.emitPostscript()
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  public deletePostscript(): void {
    if (confirm("本当に削除しますか?")) {
      api
        .deletePostscript(this.id)
        .then(() => {
          this.$toasted.success("定義を削除しました")
          this.emitPostscript()
        })
        .catch((error: AxiosError) => {
          console.log(error.stack)
          this.$toasted.error("定義の削除に失敗しました")
        })
    }
  }

  @Emit("emitPostscript")
  private emitPostscript() {
    this.close()
  }

  @Emit("close")
  private close() {
    this.clear()
  }

  private created() {
    this.getAlertLevels()
  }

  private getAlertLevels() {
    api
      .getAlertLevels()
      .then((response) => {
        this.alertLevels = response.data
      })
      .catch(() => {
        this.$toasted.error("警告レベルの取得に失敗しました")
      })
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditPostscript>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditPostscript>
    return form.resetValidation()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.id = -1
    this.alertLevel = ""
    this.category = ""
    this.invalidText = ""
    this.validText = ""
    this.description = ""
  }
}
